import tokens from './designTokens.json';

/**
 * Hex colours for the places a Tailwind class cannot reach: FontAwesome
 * `color` props, canvas and SVG fills, and the few inline styles that survive.
 *
 * Values come from `./designTokens.json`, the same file `tailwind.config.js`
 * builds its utility classes from — so a colour is written down once and both
 * sides of the app agree by construction. Anything that CAN be a class should
 * be a class; this is the escape hatch.
 */

/** Neutrals. */
export const NEUTRAL = tokens.gray[600];
export const NEUTRAL_STRONG = tokens.gray[900];
export const NEUTRAL_SURFACE = tokens.gray[100];

/** The app's danger colour, mirroring the `dangerColor` Tailwind token. */
export const DANGER = '#e74c3c';

/**
 * Categorical scale for the diagram timeline: one hue per save reason and per
 * op kind, chosen to stay distinguishable side by side rather than to carry
 * status meaning.
 */
export const CATEGORY = {
  cyan: tokens.theme.cyan,
  neutral: NEUTRAL,
  green: tokens.theme.green,
  blue: tokens.theme.blue,
  orange: tokens.theme.orange,
  pink: tokens.theme.pink,
  purple: tokens.theme.purple,
  teal: tokens.theme.teal,
  red: tokens.theme.red,
};
